export default __webpack_public_path__ + "static/media/closet4-1024w.139f1e6d.png";